<template>
  <div style="padding: 20px; background: #fff" v-if="isShowFooterBtnPanel">
    <template v-for="(item, index) of lastBtnList">
      <el-button
        v-if="!item.disabled"
        :type="item.type"
        :key="index"
        :disabled="item.disabled"
        @click="btnHandler(item.clickName, item.params)"
        class="fixed-bottom-btn"
        >{{ item.title }}
      </el-button>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'FooterBtnGroup',
    props: {
      currentStatus: {
        type: String,
        default: '',
      },
      contractStatus: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        btnList: [
          {
            title: '保存',
            type: 'primary',
            clickName: 'saveHandler',
            key: 'save',
          },
          {
            title: '保存',
            type: 'primary',
            clickName: 'saveAgreementHandler',
            key: 'saveAgreement',
          },
          {
            title: '提交',
            type: 'primary',
            clickName: 'submitHandler',
            key: 'submit',
          },
          {
            title: '提交审批',
            type: 'primary',
            clickName: 'approvalHandler',
            key: 'approval',
          },

          {
            title: '编辑',
            type: 'primary',
            clickName: 'editHandler',
            key: 'edit',
          },
          {
            title: '关闭',
            type: 'danger',
            clickName: 'closeHandler',
            key: 'close',
          },
          {
            title: '删除',
            type: 'danger',
            clickName: 'deleteHandler',
            key: 'delete',
          },
          {
            title: '通过',
            type: 'primary',
            clickName: 'passHandler',
            key: 'pass',
          },
          {
            title: '驳回',
            type: 'danger',
            clickName: 'rejectHandler',
            key: 'reject',
          },
          {
            title: '编辑',
            type: 'primary',
            clickName: 'editAgreementHandler',
            key: 'editAgreement',
          },
          {
            title: '取消',
            type: 'info',
            clickName: 'cancelHandler',
            key: 'cancel',
          },
          {
            title: '补充协议',
            type: 'primary',
            clickName: 'supplementAgreementHandler',
            key: 'supplementAgreement',
          },
          {
            title: '续签',
            type: 'primary',
            clickName: 'renewHandler',
            key: 'renew',
          },
          {
            title: '变更合同信息',
            type: 'primary',
            clickName: 'changeContractHandler',
            key: 'changeContract',
          },
          {
            title: '变更主体',
            type: 'primary',
            clickName: 'changeHandler',
            key: 'change',
          },
        ],
        lastBtnList: [],
        isShowFooterBtnPanel: true,
      };
    },
    methods: {
      // 动态派发事件上去
      btnHandler(clickName, params) {
        this.$emit('btnHandler', clickName, params);
      },
      disabledBtnHandler(contractStatus) {
        const currentStatus = this.$route.query.status;
        let lastBtnList = [];
        if (['editAgreement', 'renew', 'change', 'create'].includes(currentStatus)) {
          lastBtnList = this.btnList.map((item) => {
            if (['editAgreement', 'create'].includes(currentStatus)) {
              if (['save', 'submit', 'cancel'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (['change', 'renew'].includes(currentStatus)) {
              if (['submit', 'cancel'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            }
          });
        } else {
          lastBtnList = this.btnList.map((item) => {
            if (contractStatus == '01') {
              // 已保存
              if (['save', 'submit', 'cancel'].includes(item.key)) {
                // if (['save', 'submit', 'delete'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (contractStatus == '02') {
              // 待审批
              if (['cancel', 'pass', 'reject'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (contractStatus == '03') {
              // 已生效
              if (['cancel', 'close'].includes(item.key)) {
                // if (['supplementAgreement', 'renew', 'change', 'changeContract'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (contractStatus == '04') {
              // 已驳回
              if (['cancel', 'save', 'submit'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (contractStatus == '05') {
              // 已关闭
              if (['cancel'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (contractStatus == '06') {
              // 已到期
              if (['renew'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else {
              // 属于创建的时候
              if (['save', 'submit', 'cancel'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            }
          });
        }
        this.lastBtnList = lastBtnList;
        this.isShowFooterBtnPanel = !this.lastBtnList.every((item) => item?.disabled);
      },
    },
    watch: {
      contractStatus: {
        handler(val) {
          this.disabledBtnHandler(val);
        },
        immediate: true,
      },
    },
  };
</script>

<style></style>
